<app-right-side-panel
  class="overlay-right-panel"
  [title]="translations.completedRiskAssessments"
  [displayTopButtons]="false"
  [displayAddAllButton]="false"
  [availableItems]="availableReports()"
  [isLoadingItems]="isLoading()"
  [isAdvancedSearch]="true"
  [showAddItemsText]="false"
>
  <div advanced-search [formGroup]="form">
    <app-input-select
      class="no-padding"
      formControlName="resourceType"
      [options]="resourceTypeOptions"
      [showOptionalHint]="false"
    />
  </div>

  <div class="items-container">
    @if (isLoading()) {
      <app-loader></app-loader>
    } @else {
      @for (report of availableReports(); track $index) {
        <app-draggable-card [draggable]="false" (pressed)="onAdd(report)">
          <div class="container-flex-space-between">
            <div class="left-content">
              <div class="name bold container-flex">
                @if (report.record.type === type.COUNTRY) {
                  <app-flag [country]="report.record.code" />
                }

                {{ report.record.name }}
              </div>
              <div class="description">
                {{ translations.completedDate }}:
                {{ report.completedDate ? (report.completedDate | appDate) : "-" }}
              </div>

              <div class="description">
                {{ translations.validUntil }}:
                {{ report.validUntilDate ? (report.validUntilDate | appDate) : "-" }}
              </div>
              <app-basic-tags
                appearance="in-card"
                [tags]="report.residualRisk ? [report.residualRisk] : []"
              />
            </div>

            <app-button size="medium" type="icon">
              <mat-icon icon-medium-18>add</mat-icon>
            </app-button>
          </div>
        </app-draggable-card>
      }
    }
  </div>
</app-right-side-panel>
